import axios from 'axios';

// Base API URL
const API_BASE_URL = process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:8000/api');

// Create axios instance with default config
const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Request interceptor to add auth token to all requests
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('authToken');
        if (token) {
            config.headers.Authorization = `Token ${token}`;
        }
        if (config.data instanceof FormData) {
            delete config.headers['Content-Type'];
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor for error handling
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            // Unauthorized - clear token and redirect to login
            localStorage.removeItem('authToken');
            localStorage.removeItem('user');
        }
        return Promise.reject(error);
    }
);

// Level Admin Permissions

export const getLevelAdminPermissions = async () => {
    try {
        const response = await api.get(`/levels/admin-permissions/`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const createLevelAdminPermission = async (permissionData) => {
    try {
        const response = await api.post(`/levels/admin-permissions/`, permissionData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const updateLevelAdminPermission = async (permissionId, permissionData) => {
    try {
        const response = await api.patch(`/levels/admin-permissions/${permissionId}/`, permissionData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const deleteLevelAdminPermission = async (permissionId) => {
    try {
        const response = await api.delete(`/levels/admin-permissions/${permissionId}/`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

// Topic Admin Permissions

export const getTopicAdminPermissions = async () => {
    try {
        const response = await api.get(`/topics/admin-permissions/`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const createTopicAdminPermission = async (permissionData) => {
    try {
        const response = await api.post(`/topics/admin-permissions/`, permissionData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const updateTopicAdminPermission = async (permissionId, permissionData) => {
    try {
        const response = await api.patch(`/topics/admin-permissions/${permissionId}/`, permissionData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const deleteTopicAdminPermission = async (permissionId) => {
    try {
        const response = await api.delete(`/topics/admin-permissions/${permissionId}/`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

// Exam Admin Permissions

export const getExamAdminPermissions = async () => {
    try {
        const response = await api.get(`/exams/admin-permissions/`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const createExamAdminPermission = async (permissionData) => {
    try {
        const response = await api.post(`/exams/admin-permissions/`, permissionData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const updateExamAdminPermission = async (permissionId, permissionData) => {
    try {
        const response = await api.patch(`/exams/admin-permissions/${permissionId}/`, permissionData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const deleteExamAdminPermission = async (permissionId) => {
    try {
        const response = await api.delete(`/exams/admin-permissions/${permissionId}/`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

// Chapter Admin Permissions

export const getChapterAdminPermissions = async () => {
    try {
        const response = await api.get(`/chapters/admin-permissions/`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const createChapterAdminPermission = async (permissionData) => {
    try {
        const response = await api.post(`/chapters/admin-permissions/`, permissionData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const updateChapterAdminPermission = async (permissionId, permissionData) => {
    try {
        const response = await api.patch(`/chapters/admin-permissions/${permissionId}/`, permissionData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const deleteChapterAdminPermission = async (permissionId) => {
    try {
        const response = await api.delete(`/chapters/admin-permissions/${permissionId}/`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

// Test Admin Permissions

export const getTestAdminPermissions = async () => {
    try {
        const response = await api.get(`/tests/admin-permissions/`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const createTestAdminPermission = async (permissionData) => {
    try {
        const response = await api.post(`/tests/admin-permissions/`, permissionData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const updateTestAdminPermission = async (permissionId, permissionData) => {
    try {
        const response = await api.patch(`/tests/admin-permissions/${permissionId}/`, permissionData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const deleteTestAdminPermission = async (permissionId) => {
    try {
        const response = await api.delete(`/tests/admin-permissions/${permissionId}/`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};